module.exports = __webpack_public_path__ + "static/fonts/Mont-ExtraLight.64b4d4c.woff";